
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/datasheet/[productModel]/[catalogId]",
      function () {
        return require("private-next-pages/datasheet/[productModel]/[catalogId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/datasheet/[productModel]/[catalogId]"])
      });
    }
  